// extracted by mini-css-extract-plugin
module.exports = {"welcomeMessage":"OutstandingPaymentsDialog_welcomeMessage__1pQ7Q"};